import { HTTPClientInterface, HTTPRequest } from '@shared/core/HTTPClientInterface';
import { buildURL, SystemURL } from './URLCatalog';

/** Check-in channel of the organization (system-configuration "communication-channel-configuration") */
export type CommunicationChannel = 'WHATSAPP' | 'WEBAPP' | 'TELEGRAM';

export class CommunicationChannelService {
    private httpClient: HTTPClientInterface;

    constructor(httpClient: HTTPClientInterface) {
        this.httpClient = httpClient;
    }

    async getChannel(orgId: string): Promise<CommunicationChannel | undefined> {
        const request = new HTTPRequest();
        request.url = buildURL(SystemURL.QontactPoints.getCommunicationChannel, { org_id: orgId });
        request.method = 'GET';
        const response = await this.httpClient.execute(request);
        const channel = response.result?.channel;
        return channel === 'WHATSAPP' || channel === 'WEBAPP' || channel === 'TELEGRAM' ? channel : undefined;
    }
}
